import { route } from "../../../application/domain/routing/named-route";
import { REG_EXP_STR_FOR_UUID } from "../../../utils/url-utils";
import { AuthedRoute } from "../../helpers/authed-route";
import { ShortcutDetailContainer } from "./shortcut-detail";
import { ShortcutCreateContainer } from "./shortcuts-create";
import { ShortcutEditContainer } from "./shortcuts-edit";
import { ShortcutListContainer } from "./shortcuts-list";
import { NoticeList } from "./notices-list";
import { NoticeCreate } from "./notices-create";
import { NoticeEdit } from "./notices-edit";
import { PortalHome } from "./home";
import { PortalConfigEdit } from "./cofnig-edit";

export const TtzkPortalR = {
  Home: route({
    path: "/ttzk-portal",
    component: PortalHome,
  }),

  // /shortcuts
  ShortcutList: route({
    path: "/ttzk-portal/shortcuts",
    link: (args: { page?: number; q?: string }) => {
      const queries = [];
      if (typeof args.q === "string") {
        queries.push(`q=${args.q}`);
      }
      if (typeof args.page === "number") {
        queries.push(`page=${args.page}`);
      }
      return `/ttzk-portal/shortcuts${
        queries.length > 0 ? `?${queries.join("&")}` : ""
      }`;
    },
    component: ShortcutListContainer,
  }),
  ShortcutCreate: route({
    path: "/ttzk-portal/shortcuts/new",
    component: ShortcutCreateContainer,
  }),
  ShortcutDetail: route({
    path: `/ttzk-portal/shortcuts/:shortcutId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { shortcutId: string }) => {
      return `/ttzk-portal/shortcuts/${args.shortcutId}`;
    },
    component: ShortcutDetailContainer,
  }),
  ShortcutEdit: route({
    path: `/ttzk-portal/shortcuts/:shortcutId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { shortcutId: string }) => {
      return `/ttzk-portal/shortcuts/${args.shortcutId}/edit`;
    },
    component: ShortcutEditContainer,
  }),

  //notices
  NoticeList: route({
    path: "/ttzk-portal/notices",
    link: (args: { page?: number }) => {
      const queries = [];
      if (typeof args.page === "number") {
        queries.push(`page=${args.page}`);
      }
      return `/ttzk-portal/notices${
        queries.length > 0 ? `?${queries.join("&")}` : ""
      }`;
    },
    component: NoticeList,
  }),
  NoticeCreate: route({
    path: "/ttzk-portal/notices/new",
    component: NoticeCreate,
  }),
  NoticeEdit: route({
    path: `/ttzk-portal/notices/:noticeId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { noticeId: string }) => {
      return `/ttzk-portal/notices/${args.noticeId}/edit`;
    },
    component: NoticeEdit,
  }),
  ConfigEdit: route({
    path: "/ttzk-portal/config",
    component: PortalConfigEdit,
  }),
};

export const TtzkPortalRoute: React.FC = () => {
  return (
    <>
      {Object.entries(TtzkPortalR).map(([key, route]) => {
        return (
          <AuthedRoute
            exact
            path={route.forRouter.path}
            component={route.forRouter.component}
            key={`TtzkPortalRoute-${key}`}
          />
        );
      })}
    </>
  );
};
